import { render, staticRenderFns } from "./pending-prescription-whatsapp-modal.vue?vue&type=template&id=705964b4&scoped=true&lang=pug&"
import script from "./pending-prescription-whatsapp-modal.vue?vue&type=script&lang=ts&"
export * from "./pending-prescription-whatsapp-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705964b4",
  null
  
)

export default component.exports